export default __webpack_public_path__ + "static/media/molo-design03.f8226fd4.jpg";